import React, { useState } from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
// Import Modal
import Modal from "react-bootstrap/Modal";

//import Alert
// import { toast } from "react-toastify";

// Import service
// import TimeregService from "../../services/timereg.service";
import authService from "../../services/auth.service";

//Import Form
import { Form, Col, Row, FormControl } from "react-bootstrap";

// import moment from "moment";
// import OverwriteMomentBE from "../../components/DatePicker/OverwriteMomentBE";
// import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";

//Import module for datePicker
// import dayjs from "dayjs";
import { WatDatePicker } from "thaidatepicker-react";

//Import farmer.css
import "./timereg.css";

// Style for valid
const valid = {
  display: "block",
  width: "100%",
  padding: "0.375rem 0.75rem",
  fontSize: "1rem",
  fontWeight: 400,
  lineHeight: 1.5,
  color: "#212529",
  backgroundColor: "#fff",
  backgroundClip: "padding-box",
  border: "1px solid #ced4da",
  appearance: "none",
  borderRadius: "0.25rem",
  transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
};

//Style for invalid
const invalid = {
  display: "block",
  width: "100%",
  padding: "0.375rem 0 0.375rem",
  fontSize: "1rem",
  fontWeight: 400,
  lineHeight: 1.5,
  color: "#212529",
  backgroundColor: "#fff",
  backgroundClip: "padding-box",
  border: "1px solid #dc3545",
  appearance: "none",
  borderRadius: "0.25rem",
  transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
  paddingRight: "calc(1.5em + 0.75rem)",
  backgroundImage:
    'url(\'data:image/svg+xml,%3csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width="12" height="12" fill="none" stroke="%23dc3545"%3e%3ccircle cx="6" cy="6" r="4.5"/%3e%3cpath stroke-linejoin="round" d="M5.8 3.6h.4L6 6.5z"/%3e%3ccircle cx="6" cy="8.2" r=".6" fill="%23dc3545" stroke="none"/%3e%3c/svg%3e\')',
  backgroundRepeat: "no-repeat",
  backgroundPosition: "right calc(0.375em + 0.1875rem) center",
  backgroundSize: "calc(0.75em + 0.375rem) calc(0.75em + 0.375rem)",
};

function ModalEditStatus(props) {
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [selectEndDate, setSelectEndDate] = useState("");
  // const [selectedDate, handleSelectedDateChange] = useState(
  //   moment().add(0, "years")
  // );

  const handleEndtDateChange = (christDate, buddhistDate) => {
    console.log(buddhistDate);
    setSelectEndDate(christDate);
    // Check click remove date
    if (christDate) {
      setForm({
        ...form,
        ["end_date"]: christDate,
      });
    } else {
      setForm({
        ...form,
        ["end_date"]: "",
      });
    }
    //Set error to Null
    setErrors({
      ...errors,
      ["end_date"]: null,
    });
  };

  const handleClose = () => {
    initialForm();
    props.hidden(false);
  };

  const initialForm = () => {
    setForm({});
    setErrors({});
    setSelectEndDate("");
  };
  const setField = (field, value) => {
    setForm({
      ...form,
      [field.name]: value,
    });
    if (errors[field.name])
      setErrors({
        ...errors,
        [field.name]: null,
      });
  };
  const findFormErrors = () => {
    const { status, end_date } = form;
    const newErrors = {};

    // end date errors
    if (!end_date || end_date === "")
      newErrors.end_date = "กรุณากรอกวันสิ้นสุด";

    // description errors
    if (!status || status === "" || status === "ชาวไร่")
      newErrors.status = "กรุณาระบุสถานะ";

    return newErrors;
  };

  const handleSubmit = (e) => {
    // console.log(form);
    // const data = new FormData();
    // for (const key in form) {
    //   data.append(key, form[key]);
    // }
    e.preventDefault();
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      const user = authService.getCurrentUser();
      // setForm({
      //   ...form,
      //   ["user_reg"]: user.user.user_reg,
      // });
      form.user_id = user.user.user_id;
      form.master_id = props.master_id;
      props.afterSubmit(form);
      initialForm();
      //   TimeregService.createTimereg(user.user.user_id, form)
      //     .then((response) => {
      //       if (response.data.success) {
      //         props.setdata([response.data.data, ...props.data]);
      //         initialForm();
      //         props.hidden(false);
      //       } else {
      //         toast.error(response.data.message);
      //       }
      //     })
      //     .catch((error) => {
      //       toast.error(error);
      //     });
    }
  };
  return (
    <>
      <Modal size="lg" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>แก้ไขข้อมูลชาวไร่</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md="4">
                <Form.Group className="mb-2">
                  <Form.Label>สถานะชาวไร่</Form.Label>
                  <Form.Select
                    name="status"
                    value={form.status}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.status}
                  >
                    {/* <option value="ชาวไร่">ชาวไร่</option> */}
                    <option value="">กรุณาเลือกสถานะ</option>
                    <option value="เสียชีวิต">เสียชีวิต</option>
                    <option value="พ้นสภาพ">พ้นสภาพ</option>
                    <option value="ลาออก">ลาออก</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.status}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="4">
                <Form.Group className="mb-2">
                  <Form.Label>วันที่สิ้นสุด</Form.Label>
                  <WatDatePicker
                    placeholder="กรอกวันที่สิ้นสุด"
                    value={selectEndDate} // Can be replace with string or dayjs object (e.g. "2020-12-31" or `dayjs()`)
                    onChange={handleEndtDateChange}
                    dateFormat={"yyyy/MM/dd"} // for set data purpose [using date-fns format](https://date-fns.org/v2.12.0/docs/format)
                    displayFormat={"DD MMM YYYY"} // for display purpose (using dayjs format)[https://day.js.org/docs/en/display/format]
                    inputStyle={errors.end_date ? invalid : valid} // styles for input
                    clearable={true} // true | false
                    // minDate={"2020-12-26"} // supported date as string
                    maxDate={dayjs()} // also supported dayjs or moment
                    disabled={false} // true | false
                    readOnly={false} // true | false
                    yearBoundary={99} // number of boundary ±X Year
                  />
                  <div
                    className={
                      errors.end_date
                        ? "custom-valid-feedback"
                        : "custom-invalid-feedback"
                    }
                  >
                    {errors.end_date}
                  </div>
                </Form.Group>
              </Col>
              <Col md="4">
                <Form.Group className="mb-2">
                  <Form.Label>ข้อความ</Form.Label>
                  <FormControl
                    placeholder="ข้อความ"
                    type="text"
                    name="comment"
                    value={form.comment}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.comment}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.comment}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-warning" onClick={handleClose}>
            ยกเลิก
          </button>
          <button
            className="btn btn-primary"
            type="submit"
            onClick={handleSubmit}
          >
            บันทึก
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalEditStatus;

ModalEditStatus.propTypes = {
  show: PropTypes.bool,
  hidden: PropTypes.func,
  status: PropTypes.string,
  master_id: PropTypes.number,
  afterSubmit: PropTypes.func,
  //   data: PropTypes.object,
  //   setdata: PropTypes.func,
};
